import { BusinessObject } from '../../bos/business-object.js'
import { Block } from '../index.js'
import { EditorPropertiesManager } from './editor-properties-manager.js'
import {
	EditorGeneralProperty,
	ScreenEditorProperty,
} from './editor-property-types.js'

export function ScreenEditorInput<Item extends Block = Block>(
	editorProperty: ScreenEditorProperty<Item>,
): PropertyDecorator {
	return function (target: Object, propertyKey: string | symbol) {
		EditorPropertiesManager.setProperty(
			target,
			propertyKey,
			editorProperty as EditorGeneralProperty<BusinessObject, any>,
		)
	}
}
